





























































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';

interface TeknikDestekNot {
  not?: string;      // API "not" dönerse
  not_metni?: string; // API "not_metni" dönerse
  metin?: string;    // API "metin" dönerse (MySQL reserved word → columnMap)
  tarih: string;
  kullanici?: string | number; // dealer_id veya kullanıcı adı
}

/** "Kişiye Ata" listesindeki panel personeli (GET degerlendirme/personel) */
interface PersonelItem {
  id: number;
  ad: string;
  departman: string | null;
}

/** Kişiye Ata: takibi üstlenen personel, atamayı yapan ve zamanı. null: atanmamış */
interface AtamaBilgisi {
  atanan_dealer_id: number | null;
  atanan_dealer_adi: string | null;
  atayan_dealer_id: number | null;
  atayan_dealer_adi: string | null;
  atama_tarihi: string | null;
}

// "Atanan Kişi" filtresindeki özel seçenekler (personel id'leri pozitiftir)
const ATANAN_FILTRE_BANA = -2;
const ATANAN_FILTRE_ATANMAMIS = -1;
// Departmanı girilmemiş personelin listede toplandığı grup
const DEPARTMAN_YOK = 'Diğer';

interface SurveyItem extends AtamaBilgisi {
  id: number;
  anket_id?: number | null;
  product_id: number;
  product_name: string;
  sso_user_id: number;
  // SSO'suz uygulamalardan (arabulucupro) gelen cevaplarda sso_user_id 0'dır;
  // kullanıcı bu ikiliyle ayırt edilir.
  kaynak?: string | null;
  harici_kullanici_id?: number | null;
  kullanici_bilgisi: string;
  // Anketi dolduran alt kullanicinin bagli oldugu ana hesap/buro bilgisi.
  buro_adi?: string | null;
  ana_hesap_sahibi?: string | null;
  tenant_id?: string | null;
  lisans_no?: string | null;
  memnuniyet_puani: number;
  tavsiye_puani?: number | null; // Bazı ürünlerde olmayabilir
  degerlendirme_sebebi: string;
  tavsiye_metni: string;
  arandi: number | null; // 0: Aranmadı, 1: Arandı, null: Belirtilmedi
  teknik_destek_notlari?: TeknikDestekNot[]; // Birden fazla not, tarih ile
  teknik_destek_not?: string | null; // Geriye dönük uyumluluk
  created_at: string;
}

@Component({
  components: {}
})
export default class Survey extends Vue {
  items: SurveyItem[] | null = null;
  search: string = '';
  selectedProduct: number | null = null;
  selectedSatisfaction: number | null = null;
  filterArandi: number | null = null; // Excel rapor filtresi: 0 Aranmadı, 1 Arandı, null Tümü
  baseAction: string = 'degerlendirme';
  statsScope: 'all' | 'program' = 'all';
  expanded: SurveyItem[] = [];
  newNoteDrafts: Record<number, string> = {};
  savingNoteId: number | null = null;
  personel: PersonelItem[] = [];
  selectedAtanan: number | null = null; // ATANAN_FILTRE_* ya da personel id
  atamaKaydedilenId: number | null = null;

  // Note dialog
  noteDialog: boolean = false;
  noteType: string = '';
  noteContent: string = '';
  noteUser: string = '';

  // Excel export
  reportWarningDialog: boolean = false;
  exportLoading: boolean = false;

  headers = [
    { text: 'Atanan Kişi', value: 'atanan_dealer_adi', sortable: true, width: '230px' },
    { text: 'Anket ID', value: 'anket_id', sortable: true, width: '110px' },
    { text: 'Ürün/Program', value: 'product', sortable: true, width: '180px' },
    { text: 'Kullanıcı / Ana Hesap', value: 'kullanici_bilgisi', sortable: true },
    { text: 'Arandı / Aranmadı', value: 'arandi', sortable: true, align: 'center', width: '200px' },
    { text: 'Memnuniyet', value: 'memnuniyet_puani', sortable: true, align: 'center' },
    { text: 'Tavsiye Puanı', value: 'tavsiye_puani', sortable: true, align: 'center' },
    { text: 'Sebep', value: 'degerlendirme_sebebi', sortable: false, align: 'center', width: '80px' },
    { text: 'Tavsiye', value: 'tavsiye_metni', sortable: false, align: 'center', width: '80px' },
    { text: 'Tarih', value: 'created_at', sortable: true, width: '120px' }
  ];

  get hasTavsiyePuan(): boolean {
    if (!this.items || this.items.length === 0) return false;
    const hasAnyTavsiye = this.items.some(item => item.tavsiye_puani != null && item.tavsiye_puani !== undefined);
    if (!hasAnyTavsiye) return false;
    if (this.averageRecommendation === '0.0' || this.averageRecommendation === '0.00') return false;
    return true;
  }

  get filteredHeaders() {
    if (!this.hasTavsiyePuan) {
      return this.headers.filter(h => h.value !== 'tavsiye_puani' && h.value !== 'tavsiye_metni');
    }
    return this.headers;
  }

  // degerlendirme.kaynak → panelde gösterilecek uygulama adı.
  kaynakEtiketleri: Record<string, string> = {
    arabulucupro: 'ArabulucuPro'
  };

  arandiOptions = [
    { text: 'Arandı', value: 1 },
    { text: 'Aranmadı', value: 0 }
  ];

  filterArandiOptions = [
    { text: 'Arandı', value: 1 },
    { text: 'Aranmadı', value: 0 }
  ];

  satisfactionOptions = [
    { text: 'Çok Memnun (9-10)', value: 9 },
    { text: 'Memnun (7-8)', value: 7 },
    { text: 'Orta (5-6)', value: 5 },
    { text: 'Memnun Değil (3-4)', value: 3 },
    { text: 'Çok Memnun Değil (1-2)', value: 1 }
  ];

  get productOptions() {
    if (!this.items) return [];
    const uniqueProducts = new Map<number, string>();
    this.items.forEach(item => {
      if (!uniqueProducts.has(item.product_id)) {
        uniqueProducts.set(item.product_id, item.product_name);
      }
    });
    return Array.from(uniqueProducts.entries()).map(([value, text]) => ({
      text,
      value
    })).sort((a, b) => a.text.localeCompare(b.text));
  }

  /**
   * "Kişiye Ata" seçenekleri: personel departmana göre gruplanır. Silinmiş personele
   * yapılmış atamalar listede seçilemez halde durur; aksi halde hücre boş görünürdü.
   */
  get personelSecenekleri(): any[] {
    const gruplar = new Map<string, { baslik: string; kisiler: { text: string; value: number }[] }>();
    this.personel.forEach(p => {
      const baslik = this.departmanBasligi(p.departman);
      const anahtar = baslik.toLocaleLowerCase('tr');
      if (!gruplar.has(anahtar)) {
        gruplar.set(anahtar, { baslik, kisiler: [] });
      }
      gruplar.get(anahtar)!.kisiler.push({ text: p.ad, value: p.id });
    });

    const secenekler: any[] = [];
    Array.from(gruplar.values())
      .sort((a, b) => {
        if (a.baslik === DEPARTMAN_YOK) return 1;
        if (b.baslik === DEPARTMAN_YOK) return -1;
        return a.baslik.localeCompare(b.baslik, 'tr');
      })
      .forEach(grup => {
        secenekler.push({ header: grup.baslik });
        grup.kisiler
          .sort((a, b) => a.text.localeCompare(b.text, 'tr'))
          .forEach(kisi => secenekler.push(kisi));
      });

    if (this.personel.length > 0 && this.items) {
      const bilinenler = new Set(this.personel.map(p => p.id));
      const silinmisler = new Map<number, string>();
      this.items.forEach(item => {
        if (item.atanan_dealer_id != null && !bilinenler.has(item.atanan_dealer_id)) {
          silinmisler.set(item.atanan_dealer_id, item.atanan_dealer_adi || `Silinmiş personel #${item.atanan_dealer_id}`);
        }
      });
      if (silinmisler.size > 0) {
        secenekler.push({ header: 'Silinmiş personel' });
        silinmisler.forEach((text, value) => secenekler.push({ text, value, disabled: true }));
      }
    }

    return secenekler;
  }

  /** Filtre: "Bana atananlar", "Atanmamış" ve personel (silinmiş personele göre de süzülebilir) */
  get atananFiltreSecenekleri(): any[] {
    return [
      { text: 'Bana atananlar', value: ATANAN_FILTRE_BANA, disabled: this.currentUserDealerId == null },
      { text: 'Atanmamış', value: ATANAN_FILTRE_ATANMAMIS },
      { divider: true },
      ...this.personelSecenekleri.map(s => (s.disabled ? { ...s, disabled: false } : s))
    ];
  }

  /** Atanan Kişi filtresi yalnızca ekranı süzer; rapor uyarısında bunu belirt. */
  get atananRaporNotu(): string {
    if (this.selectedAtanan === null || this.selectedAtanan === undefined) return '';
    return '<br/><br/><em>Not: Atanan Kişi filtresi rapora uygulanmaz; raporda Atanan Kişi, Atayan Kişi ve Atama Tarihi kolonları yer alır.</em>';
  }

  @Watch('selectedProduct')
  onProductChange() {
    if (!this.selectedProduct && this.statsScope === 'program') {
      this.statsScope = 'all';
    }
  }

  get hasActiveFilters(): boolean {
    return !!(this.selectedProduct !== null || (this.filterArandi !== null && this.filterArandi !== undefined));
  }

  get reportWarningMessage(): string {
    if (!this.hasActiveFilters) {
      return '<strong>Tüm anket değerlendirme listesinin raporunu alacaksınız.</strong><br/>Belirli bir koşula göre filtrelemek için lütfen Ürün/Program veya Arandı/Aranmadı filtrelerini kullanın.' + this.atananRaporNotu;
    }
    const conditions: string[] = [];
    if (this.selectedProduct !== null) {
      const prod = this.productOptions.find(p => p.value === this.selectedProduct);
      conditions.push(`<strong>Ürün/Program:</strong> ${prod ? prod.text : this.selectedProduct}`);
    }
    if (this.filterArandi !== null && this.filterArandi !== undefined) {
      const arandiLabel = this.filterArandi === 1 ? 'Arandı' : 'Aranmadı';
      conditions.push(`<strong>Arandı/Aranmadı:</strong> ${arandiLabel}`);
    }
    return `Aşağıdaki koşullara göre filtrelenmiş raporunuz hazırlanacak:<br/><br/>${conditions.join('<br/>')}${this.atananRaporNotu}`;
  }

  exportToExcel(): void {
    this.reportWarningDialog = true;
  }

  async confirmExportToExcel(): Promise<void> {
    this.reportWarningDialog = false;

    try {
      this.exportLoading = true;

      const payload: Record<string, any> = {};
      if (this.selectedProduct !== null) {
        payload.product_id = [this.selectedProduct];
      }
      if (this.filterArandi !== null && this.filterArandi !== undefined) {
        payload.arandi = this.filterArandi;
      }

      const response = await this.$http.post('anket-rapor', payload, {
        responseType: 'blob',
        headers: { 'Content-Type': 'application/json' }
      });

      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      const dateStr = new Date().toISOString().split('T')[0];
      link.setAttribute('download', `anket_degerlendirme_raporu_${dateStr}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      if (this.$store?.commit) {
        this.$store.commit('snackbar', 'Rapor başarıyla indirildi');
      }
    } catch (error) {
      console.error('Rapor indirme hatası', error);
      if (this.$store?.commit) {
        this.$store.commit('snackbar', 'Rapor indirilirken bir hata oluştu');
      }
    } finally {
      this.exportLoading = false;
    }
  }

  openNote(type: string, content: string, user: string) {
    this.noteType = type;
    this.noteContent = content;
    this.noteUser = user || 'Anonim';
    this.noteDialog = true;
  }

  get filteredItems(): SurveyItem[] {
    if (!this.items) return [];

    return this.items.filter(item => {
      // Product filter
      if (this.selectedProduct !== null && item.product_id !== this.selectedProduct) {
        return false;
      }

      // Atanan kişi filtresi
      if (this.selectedAtanan !== null && this.selectedAtanan !== undefined) {
        if (this.selectedAtanan === ATANAN_FILTRE_ATANMAMIS) {
          if (item.atanan_dealer_id != null) return false;
        } else {
          const hedef = this.selectedAtanan === ATANAN_FILTRE_BANA
            ? this.currentUserDealerId
            : this.selectedAtanan;
          if (hedef == null || item.atanan_dealer_id !== Number(hedef)) return false;
        }
      }

      // Satisfaction filter
      if (this.selectedSatisfaction !== null) {
        const score = Number(item.memnuniyet_puani);
        if (this.selectedSatisfaction === 9 && score < 9) return false;
        if (this.selectedSatisfaction === 7 && (score < 7 || score > 8)) return false;
        if (this.selectedSatisfaction === 5 && (score < 5 || score > 6)) return false;
        if (this.selectedSatisfaction === 3 && (score < 3 || score > 4)) return false;
        if (this.selectedSatisfaction === 1 && score > 2) return false;
      }

      return true;
    });
  }

  get filteredItemsCount(): number {
    return this.filteredItems.length;
  }

  get statsItems(): SurveyItem[] {
    if (!this.items) return [];
    return this.statsScope === 'program' ? this.filteredItems : this.items;
  }

  get totalSurveys(): number {
    return this.statsItems.length;
  }

  get uniqueProducts(): number {
    if (!this.statsItems.length) return 0;
    return new Set(this.statsItems.map(item => item.product_id)).size;
  }

  get averageSatisfaction(): string {
    if (!this.statsItems.length) return '0.0';
    const avg = this.statsItems.reduce((sum, item) => sum + Number(item.memnuniyet_puani), 0) / this.statsItems.length;
    return avg.toFixed(1);
  }

  get averageRecommendation(): string {
    if (!this.statsItems.length) return '0.0';
    const avg = this.statsItems.reduce((sum, item) => sum + Number(item.tavsiye_puani), 0) / this.statsItems.length;
    return avg.toFixed(1);
  }

  getSatisfactionColor(score: number): string {
    if (score >= 9) return 'success';
    if (score >= 7) return 'light-green darken-1';
    if (score >= 5) return 'amber darken-2';
    if (score >= 3) return 'orange darken-2';
    return 'red darken-1';
  }

  getSatisfactionIcon(score: number): string {
    if (score >= 9) return 'mdi-emoticon-excited';
    if (score >= 7) return 'mdi-emoticon-happy';
    if (score >= 5) return 'mdi-emoticon-neutral';
    if (score >= 3) return 'mdi-emoticon-sad';
    return 'mdi-emoticon-cry';
  }

  getRecommendationColor(score: number): string {
    if (score >= 9) return 'success';
    if (score >= 7) return 'light-green darken-1';
    if (score >= 5) return 'amber darken-2';
    if (score >= 3) return 'orange darken-2';
    return 'red darken-1';
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  formatTime(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('tr-TR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getItemNotes(item: SurveyItem): TeknikDestekNot[] {
    if (item.teknik_destek_notlari && item.teknik_destek_notlari.length > 0) {
      return [...item.teknik_destek_notlari].sort((a, b) =>
        new Date(b.tarih).getTime() - new Date(a.tarih).getTime()
      );
    }
    if (item.teknik_destek_not) {
      return [{ not: item.teknik_destek_not, tarih: item.created_at }];
    }
    return [];
  }

  getNewNoteDraft(id: number): string {
    return this.newNoteDrafts[id] || '';
  }

  setNewNoteDraft(id: number, value: string) {
    this.$set(this.newNoteDrafts, id, value);
  }

  formatNoteDate(dateStr: string): string {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  /**
   * Personel listesi (Kişiye Ata + not yazarı adları). `dealer` yerine
   * degerlendirme altından alınır: yalnızca bu sayfaya yetkili kullanıcı da
   * listeyi görebilir ve parola gibi alanlar panele gelmez.
   */
  async loadPersonel() {
    try {
      const response = await this.$http.get(`${this.baseAction}/personel`);
      this.personel = (response.data || []).map((p: any) => ({
        id: Number(p.id),
        ad: p.ad,
        departman: p.departman || null
      }));
    } catch (error) {
      console.error('Personel yükleme hatası:', error);
      this.personel = [];
    }
  }

  hasTavsiyePuanDeger(val: any): boolean {
    if (val == null || val === undefined || val === '') return false;
    const num = Number(val);
    return !isNaN(num) && num > 0 && num <= 10;
  }

  getDealerDisplayName(kullanici: string | number | null | undefined): string {
    if (kullanici == null || kullanici === undefined || kullanici === '') return '';
    const dealerId = typeof kullanici === 'string' && /^\d+$/.test(kullanici) ? parseInt(kullanici, 10) : kullanici;
    if (typeof dealerId === 'number') {
      const kisi = this.personel.find(p => p.id === dealerId);
      return kisi ? kisi.ad : String(kullanici);
    }
    return String(kullanici);
  }

  /**
   * Kullanıcı hücresindeki kimlik satırı. SSO'lu cloud kayıtlarında "SSO: 123",
   * SSO'suz uygulamalardan gelenlerde (ör. arabulucupro) "ArabulucuPro #123" —
   * aksi halde bu kayıtlar "SSO: 0" görünürdü.
   */
  getKullaniciKimlikEtiketi(item: SurveyItem): string {
    if (item.kaynak) {
      const etiket = this.kaynakEtiketleri[item.kaynak] || item.kaynak;
      const id = item.harici_kullanici_id;
      return id ? `${etiket} #${id}` : etiket;
    }
    return `SSO: ${item.sso_user_id}`;
  }

  async get() {
    try {
      const response = await this.$http.get(this.baseAction);
      const data = response.data || [];
      this.items = data.map((item: any) => ({
        ...item,
        anket_id: item.anket_id ? Number(item.anket_id) : null,
        arandi: this.normalizeArandi(item.arandi),
        ...this.atamaAlanlari(item)
      }));
    } catch (error) {
      console.error('Survey data fetch error:', error);
      this.items = [];
    }
  }

  normalizeArandi(val: any): number | null {
    if (val == null || val === undefined || val === '') return null;
    const num = Number(val);
    if (num === 1) return 1;
    if (num === 0) return 0;
    return null;
  }

  /** API cevabındaki atama alanlarını satır modeline çevirir (her satırda tanımlı olsunlar: Vue reaktivitesi). */
  atamaAlanlari(kaynak: any): AtamaBilgisi {
    const pozitifId = (val: any): number | null => {
      const num = Number(val);
      return val != null && val !== '' && !isNaN(num) && num > 0 ? num : null;
    };
    return {
      atanan_dealer_id: pozitifId(kaynak.atanan_dealer_id),
      atanan_dealer_adi: kaynak.atanan_dealer_adi || null,
      atayan_dealer_id: pozitifId(kaynak.atayan_dealer_id),
      atayan_dealer_adi: kaynak.atayan_dealer_adi || null,
      atama_tarihi: kaynak.atama_tarihi || null
    };
  }

  /** Satır başındaki "Kişiye Ata" seçimi değiştiğinde kaydeder; hata olursa önceki atamaya döner. */
  async onAtananChange(item: SurveyItem, yeniId: number | null | undefined) {
    const hedefId = yeniId == null ? null : Number(yeniId);
    if (hedefId === item.atanan_dealer_id) return;

    const onceki = this.atamaAlanlari(item);
    // Seçim, sunucu cevabı gelene kadar ekranda kalsın
    Object.assign(item, {
      atanan_dealer_id: hedefId,
      atanan_dealer_adi: hedefId ? this.getDealerDisplayName(hedefId) : null
    });

    this.atamaKaydedilenId = item.id;
    try {
      const val = hedefId == null ? '' : String(hedefId);
      const response = await this.$http.patch(`${this.baseAction}/${item.id}?atanan_dealer_id=${val}`);
      Object.assign(item, this.atamaAlanlari(response.data || {}));
      this.$store.commit(
        'snackbar',
        item.atanan_dealer_id ? `Kayıt ${item.atanan_dealer_adi} kişisine atandı.` : 'Atama kaldırıldı.'
      );
    } catch (error) {
      console.error('Atama güncelleme hatası:', error);
      Object.assign(item, onceki);
      this.$store.commit('snackbar', this.hataMesaji(error, 'Atama kaydedilemedi.'));
    } finally {
      this.atamaKaydedilenId = null;
    }
  }

  /** Tooltip metni: "Caner DİKİCİ atadı · 14.09.2026 10:30" */
  getAtamaBilgisi(item: SurveyItem): string {
    if (!item.atanan_dealer_id) return '';
    const atayan = item.atayan_dealer_adi || 'Bilinmeyen personel';
    return item.atama_tarihi ? `${atayan} atadı · ${this.formatNoteDate(item.atama_tarihi)}` : `${atayan} atadı`;
  }

  departmanBasligi(departman: string | null): string {
    const d = (departman || '').trim();
    return d ? d.charAt(0).toLocaleUpperCase('tr') + d.slice(1) : DEPARTMAN_YOK;
  }

  /** Backend hata cevabından ({ messages: [{ message }] }) okunabilir mesaj çıkarır. */
  hataMesaji(error: any, varsayilan: string): string {
    const mesajlar = error?.response?.data?.messages;
    const ilk = Array.isArray(mesajlar) && mesajlar.length > 0 ? mesajlar[0].message : null;
    return ilk || varsayilan;
  }

  async onArandiChange(item: SurveyItem) {
    try {
      const val = item.arandi === null || item.arandi === undefined ? '' : String(item.arandi);
      await this.$http.patch(`${this.baseAction}/${item.id}?arandi=${val}`);
    } catch (error) {
      console.error('Arandı güncelleme hatası:', error);
      this.$store.commit('snackbar', 'Arandı bilgisi kaydedilemedi.');
      await this.get();
    }
  }

  get currentUserDealerId(): number | null {
    const user = this.$store.state.user as any;
    if (!user) return null;
    return user.dealer_id ?? user.id ?? null;
  }

  async addTeknikDestekNot(item: SurveyItem) {
    const notMetni = this.getNewNoteDraft(item.id)?.trim();
    if (!notMetni) return;

    const dealerId = this.currentUserDealerId;

    this.savingNoteId = item.id;
    try {
      const payload = {
        not_metni: notMetni,
        dealer_id: dealerId,
        kullanici: dealerId
      };
      await this.$http.request({
        method: 'POST',
        url: `${this.baseAction}/${item.id}/teknik-destek-not`,
        data: { sendJson: true, data: payload }
      });
      this.$store.commit('snackbar', 'Not eklendi.');
      this.$set(this.newNoteDrafts, item.id, '');
      await this.get();
    } catch (error) {
      console.error('Not ekleme hatası:', error);
      this.$store.commit('snackbar', 'Not eklenemedi.');
      await this.get();
    } finally {
      this.savingNoteId = null;
    }
  }

  async created() {
    await this.loadPersonel();
    await this.get();
  }
}
